
import { get, post, sendDelete } from '../helpers/api.helper';

export async function List() {
    try {
        return await get(`kit/list`);


    } catch (error) {
        console.error('Erro ao buscar dados');
    }
}

export async function GetItemsKit(id) {
    try {
        return await get(`kit/${id}/produtos`);


    } catch (error) {
        console.error('Erro ao buscar dados');
    }
}

export async function SetAsReturned(kitId) {
    try {
        let numPed = parseInt(kitId);
        return await post(`devolution`, { kitId: numPed });

    } catch (error) {
        console.error('Erro ao buscar dados');
    }
}
export async function cancelAsReturned(kitId) {
    try {
        return await sendDelete(`devolution/${kitId}`);

    } catch (error) {
        console.error('Erro ao buscar dados');
    }
}

